import severityIconNormal from './severityIconNormal.svg';
import severityIconWarning from './severityIconWarning.svg';
import severityIconError from './severityIconError.svg';
import severityIconUnknown from './severityIconUnknown.svg';

import duplicateIcon from './Duplicate.svg'

const iconLibrary = {
    severityIcon:{
        normal: severityIconNormal,
        warning: severityIconWarning,
        error: severityIconError,
        unknown: severityIconUnknown
    },
    duplicate: duplicateIcon
}

export default iconLibrary;